import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  OnInit,
} from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthService } from 'src/app/services/auth.service';
import { ClienteService } from 'src/app/services/cliente.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, NgScrollbarModule, TablerIconsModule, MaterialModule],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Input() disableLink = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleWebNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  isLoggedIn = false;
  isTempClient = false;
  isAdmin = false;
  expiringCards: any[] = [];
  expiredCards: any[] = [];
  expiringSoonCards: any[] = [];
  unreadCount = 0;

  constructor(
    private authService: AuthService,
    private clienteService: ClienteService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isAuthenticated();
    const profileId = this.authService.getProfileFromToken();
    this.isTempClient = profileId === 4;
    this.isAdmin = profileId === 1;

    if (this.isLoggedIn && this.isAdmin) {
      this.loadNotifications();
    }
  }

  loadNotifications() {
    this.clienteService.getExpiringMasterCards().subscribe({
      next: (res) => {
        this.expiringCards = res || [];
        this.expiredCards = this.expiringCards.filter(c => c.daysRemaining <= 0);
        this.expiringSoonCards = this.expiringCards.filter(c => c.daysRemaining > 0);
        this.unreadCount = this.expiringCards.length;
      },
      error: (err) => {
        console.error('Error fetching expiring cards for notifications', err);
      }
    });
  }

  logout() {
    this.isLoggedIn = false;
    this.authService.logout();
  }


  login() {
    this.router.navigate(['/authentication/login']);
  }
}